<template>
    <div>
        <LoginFormFinal
            v-if="isFinal"
            :KullaniciAdi.sync="KullaniciAdi"
            :Sifre.sync="Sifre"
            :SifreTipi="SifreTipi"
            :SifreIcon="SifreIcon"
            @submit="Login"
            @toggle-password="SifreGoster"
        />
        <LoginFormDefault
            v-else
            :KullaniciAdi.sync="KullaniciAdi"
            :Sifre.sync="Sifre"
            :SifreTipi="SifreTipi"
            :SifreIcon="SifreIcon"
            @submit="Login"
            @toggle-password="SifreGoster"
        />
    </div>
</template>

<script>
import {mapGetters} from "vuex";
// import {mapState} from "vuex";
import LmsService from '@/services/lms.service';
import ContentService from '@/services/content';
import { colorShades, getTextColorBasedOnBackground } from "@/global/color";
import LoginFormDefault from "./LoginFormDefault";
import LoginFormFinal from "./LoginFormFinal";
export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name:"login",
    components: {
        LoginFormDefault,
        LoginFormFinal,
    },
    data() {
        return {   
            AutoLogin: false,
            color: "#012866",
            Pasif:0,
            PasifMesaj: null,
    //   RenkTonlama: 5,
    //   RenkTonlari: [],
            THMBackgroundColor: null,
            KullaniciAdi: '',
            Sifre: '',
            Giris : false, 
            SifreTipi: 'password',
            SifreIcon: 'feather-eye',
            // eslint-disable-next-line no-useless-escape
            reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
        
        }
    },

    async beforeMount() {        
        if (this.$route.query.username && this.$route.query.password) {
            this.KullaniciAdi = window.atob(this.$route.query.username)
            this.Sifre = window.atob(this.$route.query.password)
		    this.AutoLogin = true
        }    
		 await this.OkulAyarlar();
         this.Tawk();
	},

    async mounted() {

	},

    computed:{
        ...mapGetters(['getOkulAyarlar','Button1StyleObject','InputStyleObject']),
        // ...mapState(['OkulAyarlar']),
        isFinal(){
            return this.$store.state.DomainAdi=='fnlenglish.com'
        },
    },
    methods: {
        RenkTonlariOlustur(Renk) {
            // this.RenkTonlari = colorShades(Renk, this.RenkTonlama);
            this.$store.state.RenkTonlari = colorShades(Renk, this.$store.state.RenkTonlama).map((shadeHex) => {
            const textColor = getTextColorBasedOnBackground(shadeHex); // Metin rengi belirleme
            return { color: shadeHex, textColor };
            });
        },
        ZeminRengiIcinYazi(Renk) {
            return getTextColorBasedOnBackground(Renk); // Metin rengi belirleme        
        },

        async OkulAyarlar() {
            this.$store.state.DomainAdi = window.location.hostname == 'localhost' ? this.$store.state.TestDomainAdi : window.location.hostname.replace('www.','')
            const obj = {
                DomainAdi : window.location.hostname == 'localhost' ? this.$store.state.TestDomainAdi : window.location.hostname.replace('www.','') //window.location.hostname.replace('www.',''),//'fnlenglish.com',
            }

            try {
                this.$store.commit('setLoading', true)
                
                const TemaData = await LmsService.OkulAyarlar(obj)
				// if(!TemaData ){
                    // this.$store.state.OkulAyarlar = TemaData
                    this.$store.commit('setOkulAyarlar', TemaData)
                    this.$store.commit('setStorageOkulAyarlar', TemaData)
                    this.RenkTonlariOlustur(this.$store.state.OkulAyarlar.BackgroundColor)
                    this.Pasif = TemaData?.Pasif ?? 0
                    this.PasifMesaj = TemaData?.PasifMesaj ?? 'Şu anda sistem altyapısı çalışmaları ve(ya) size ait içeriklere ilişkin veri güncellemeleri yapılmaktadır. Lütfen daha sonra tekrar giriş yapmayı deneyiniz.'
				// }
                this.$store.commit('setLoading', false)

                if (this.Pasif == 1){
                    this.$swal.fire({
                        title: 'Bilgilendirme !',
                        text: this.PasifMesaj,
                        icon: 'info',
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Kapat'
                    })
                } else {
                    if(this.AutoLogin){
                        await this.Login();                        
                    }
                }

			} catch (error) {
                this.$store.commit('setLoading', false)
				this.$toast.open({
					message: "Okul Tema bilgileri bulunamadı.",
					type: "error",
					duration: 3000,
					dismissible: true,
					position : 'top'
				})
				return
			}
        },

        Tawk(){
            // const param = '5d16185553d10a56bd7c54f7' // burayı API'den veya store'dan alabilirsin
            const param = this.$store.state.OkulAyarlar?.TawkKey ?? ''
            if (param.length > 0){
                const s1 = document.createElement("script")
                s1.async = true
                s1.src = `https://embed.tawk.to/${param}/default`
                s1.charset = 'UTF-8'
                s1.setAttribute('crossorigin', '*')
                document.body.appendChild(s1)
            }
        },

        SifreGoster() {
            if(this.SifreTipi === 'text') {
                this.SifreTipi = 'password'
                this.SifreIcon = 'feather-eye'
            } else {
                this.SifreTipi = 'text'
                this.SifreIcon = 'feather-eye-off'
            }
        },

        // async AutoLogin() {
        //     console.log(this.$route.query.username, this.$route.query.password)
        //     if (this.$route.query.username && this.$route.query.password) {
        //         this.KullaniciAdi = window.atob(this.$route.query.username)
        //         this.Sifre = window.atob(this.$route.query.password)
        //         this.Login();
        //     }            
        // },

        async Login() {

            if(this.Pasif == 0){            
                this.Giris = true

                const obj = {
                    email: this.KullaniciAdi,
                    password: this.Sifre,
                    api_key: this.$store.state.OkulAyarlar.ApiKey,
                }

                try {
                    this.$store.commit('setLoading', true)
                    const res = await LmsService.UesLmsTokenAl(obj)
                    if(res.success == false){
                        this.$store.commit('setLoading', false)                    
                        this.$toast.open({
                            message: res.data,
                            type: "error",
                            duration: 3000,
                            dismissible: true,
                            position : 'top'
                        })
                    }else{
                        this.KullaniciBilgiAl(this.KullaniciAdi, this.Sifre)                        
                    } 
                } catch (error) {

                    this.$store.commit('setLoading', false)
                    this.$toast.open({
                        message: error.message,
                        type: "error",
                        duration: 3000,
                        dismissible: true,
                        position : 'top'
                    })
                    return
                }
            }
        },

        // async KullaniciBilgiAl() {
        //     try {
        //         const res = await LmsService.KullaniciBilgiAl()

        //         const KullaniciData = res.data.data
        //         KullaniciData.KullaniciAdi = this.KullaniciAdi
        //         KullaniciData.Sifre = this.Sifre

        //         this.$store.commit('setKullaniciDetaylari', KullaniciData)
        //         this.$store.commit('setStorageKullaniciDetaylari', KullaniciData)                

        //         this.$store.commit('setLoading', false)
        //         this.$router.push( { path : "/home"} )

		// 	} catch (error) {
        //         this.$store.commit('setLoading', false)

		// 		this.$toast.open({
		// 			message: error.message,
		// 			type: "error",
		// 			duration: 3000,
		// 			dismissible: true,
		// 			position : 'top'
		// 		})
		// 		return
		// 	}
        // },

        async KullaniciBilgiAl() {
            try {
                this.$store.commit('setLoading', true)                    
                const res = await LmsService.KullaniciBilgiAl(this.KullaniciAdi, this.Sifre)
                this.$store.commit('setLoading', false)                    

                if(res.success == false){
                    this.$toast.open({
                        message: res.data,
                        type: "error",
                        duration: 3000,
                        dismissible: true,
                        position : 'top'
				    })
                }else{
                    this.$store.commit('setLoading', false)
                    this.$router.push( { path : "/home"} )

                    if(this.$store.state.KullaniciDetaylari.role_type =='teacher'){
                        ContentService.OgretmenOgrencileriGetir(this.$store.state.KullaniciDetaylari.organization)
                    }                    
                } 
                this.$store.commit('setLoading', false)            


			} catch (error) {
                this.$store.commit('setLoading', false)

				this.$toast.open({
					message: error.message,
					type: "error",
					duration: 3000,
					dismissible: true,
					position : 'top'
				})
				return
			}
        },
    },

}
</script>

<style scoped>


/* .THMbutton {
    background: var(--color);
    border-color: var(--color);
}

.THMbutton:hover {
    background: var(--color-hover);
    border-color: var(--color-hover);
}

.THMinput {
    border-color: var(--border-color);
}

.THMinput:focus {
    border-color: var(--focus-color);
} */




</style>
